__turbopack_context__.v({
  "Panel": "mobile-header-module__XYdJXW__Panel",
  "Scrolled": "mobile-header-module__XYdJXW__Scrolled",
  "Top": "mobile-header-module__XYdJXW__Top",
});
